import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {InstitutionService} from '../../../services/institution.service';
import {BranchService} from '../../../services/branch.service';
import {PriceListService} from "../../../../product/services/price-list.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-branch-add',
  templateUrl: './branch-add.component.html',
  styleUrls: ['./branch-add.component.scss']
})
export class BranchAddComponent implements OnInit {

  branchForm: FormGroup;

  priceLists: any[] = [];
  priceListSelected: number | undefined;
  institutions: any[] = [];
  institutionSelected: number | undefined;
  saving = false;

  public data: any;

  isSubmitted = false;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private branchService: BranchService,
              private priceListService: PriceListService,
              private institutionService: InstitutionService,
              private translate: TranslateService,
              public activeModal: NgbActiveModal,
              private toast: ToastrService,
              public route: Router
  ) {
    this.branchForm = this.fb.group({
      institution: ['', Validators.required],
      code: ['', [Validators.required]],
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      phone: [''],
      address: [''],
      nsifEmployerMatriculeNo: [''],
      priceLists: '',
      isEnable: '',
    });

  }

  ngOnInit(): void {
    this.branchForm.get('isEnable')?.setValue('1');
    this.branchForm.patchValue(this.data);
    this.findPriceLists();
    this.findInstitutions();
    //this.branchForm.get('isEnable')?.setValue(x.isEnable ? '1' : '0');
  }

  get fc(): any {
    return this.branchForm.controls;
  }

  onFormSubmit(): void {
    this.isSubmitted = true;
    // if (this.userForm.valid && this.fileHad && this.fileHad.name){
    if (this.branchForm.valid) {
      this.saving = true;
      this.branchForm.get('isEnable')?.setValue(this.branchForm.get('isEnable')?.value === '1');
      this.branchService.post(this.branchForm.value).subscribe({
        next: (val: any) => {
          console.log(val);
          this.toast.success(this.translate.instant('branch') + ' ' + this.translate.instant('createed') + ' ' + this.translate.instant('successfully!'), 'Success');
          // this.route.navigate(['/security/branch']);
          // this.activeModal.close();
          this.branchForm.reset();
          this.branchForm.get('isEnable')?.setValue('1');
        },
        complete: () => {
          this.saving = false;
        },
        error: (err: any) => {
          console.log(err);
          const errors: any[] = err.violations;
          // console.log(errors);
          if (err.violations){
            err.violations.forEach((v) => {
              if (v.propertyPath === 'code') {
                this.branchForm.get('code')?.setErrors({serverError: v.message});
              }
              if (v.propertyPath === 'name') {
                this.branchForm.get('name')?.setErrors({serverError: v.message});
              }
              if (v.propertyPath === 'phone') {
                this.branchForm.get('phone')?.setErrors({serverError: v.message});
              }
              if (v.propertyPath === 'email') {
                this.branchForm.get('email')?.setErrors({serverError: v.message});
              }

              this.saving = false;
            });
          }
          else {

            this.toast.error(err['hydra:description'], 'Error');
            this.saving = false;
          }

        }
      });

    }
  }

  findInstitutions(): any {
    this.institutionService.getCollection().subscribe((data: any) => {
          console.log(data);
          this.institutions = data['hydra:member'];
          this.institutions = this.institutions.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  }
  findPriceLists(): any{
    this.priceListService.getCollection().subscribe((data: any) => {
          console.log(data);
          this.priceLists = data['hydra:member'];
          this.priceLists = this.priceLists.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  }


}